import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { ISideNavStyles } from "../../styles";

export const useSideNavStyles = (theme?: ITheme): ISideNavStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        sideNavContainer: {
            backgroundColor: theme.palette.background.light,
        },
        sideNavContainerCollapsed: {
            maxWidth: "4.5em"
        },
        sideNavContainerExpanded: {
            minWidth: "225px",
        },
        sideNavItem: {
            fontFamily: theme.font.family,
            color: theme.palette.text.dark,
            fontSize: theme.font.sizes.lg,
            textTransform: "none",
            textDecoration: "none",
            borderRadius: theme.shape.borderRadiusSm,
        },
        sideNavItemActive: {
            backgroundColor: theme.palette.accent.dark,
            color: theme.palette.white,
        },
        sideNavItemTextCollapsed: {
            display: "none",
        },
        sideNavItemTextExpanded: {
            display: "unset",
        },
        sideNavItemTextTooltip: {
            color: theme.palette.white,
            backgroundColor: theme.palette.text.dark,
        },
        sideNavItemToggle: {
            fontSize: theme.font.sizes.xxl,
        }
    }
}